module.exports = __webpack_public_path__ + "media/images/games/35gender/punching-12b25965293a8a1ce131578a1ca22c1d.png";